var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 54,
    viewBox: "0 0 56 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21_351",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 54
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0862 0H9.91383C4.43857 0 0 4.43857 0 9.91383V44.0862C0 49.5614 4.43857 54 9.91383 54H46.0862C51.5614 54 56 49.5614 56 44.0862V9.91383C56 4.43857 51.5614 0 46.0862 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21_351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0862 0H9.91383C4.43857 0 0 4.43857 0 9.91383V44.0862C0 49.5614 4.43857 54 9.91383 54H46.0862C51.5614 54 56 49.5614 56 44.0862V9.91383C56 4.43857 51.5614 0 46.0862 0Z",
    fill: "url(#paint0_linear_21_351)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_dddddddd_21_351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4894 45.9854C13.9502 45.9854 12.9302 44.3743 13.4868 42.9392C15.3957 38.0178 16.4427 32.6666 16.4427 27.0708C16.4427 21.4751 15.3957 16.1239 13.4868 11.2025C12.9302 9.76739 13.9502 8.15625 15.4894 8.15625C16.3271 8.15625 17.0881 8.65439 17.3949 9.43393C19.5446 14.896 20.7253 20.8455 20.7253 27.0708C20.7253 33.2962 19.5446 39.2457 17.3949 44.7078C17.0881 45.4873 16.3271 45.9854 15.4894 45.9854Z",
    fill: "url(#paint1_linear_21_351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7584 41.7029C24.3483 41.7029 23.3324 40.3498 23.6511 38.9762C24.5386 35.1512 25.0078 31.1658 25.0078 27.0708C25.0078 22.9759 24.5386 18.9905 23.6511 15.1655C23.3324 13.7919 24.3483 12.4388 25.7584 12.4388C26.718 12.4388 27.5618 13.0833 27.7817 14.0174C28.7684 18.2084 29.2904 22.5787 29.2904 27.0708C29.2904 31.563 28.7684 35.9333 27.7817 40.1243C27.5618 41.0584 26.718 41.7029 25.7584 41.7029Z",
    fill: "url(#paint2_linear_21_351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4633 35.2791C34.173 35.2791 33.1813 34.1419 33.3022 32.8573C33.4813 30.9526 33.5729 29.0224 33.5729 27.0708C33.5729 25.1193 33.4813 23.1891 33.3022 21.2844C33.1813 19.9998 34.173 18.8626 35.4633 18.8626C36.5382 18.8626 37.4488 19.6625 37.5518 20.7324C37.7527 22.8181 37.8555 24.9325 37.8555 27.0708C37.8555 29.2092 37.7527 31.3236 37.5518 33.4093C37.4488 34.4792 36.5382 35.2791 35.4633 35.2791Z",
    fill: "url(#paint3_linear_21_351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.371 24.333L45.5947 25.5567C46.431 26.393 46.431 27.7487 45.5947 28.585L44.371 29.8087C43.4717 30.708 41.9341 30.071 41.9341 28.7993V25.3424C41.9341 24.0706 43.4717 23.4337 44.371 24.333Z",
    fill: "url(#paint4_linear_21_351)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iii_21_351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4894 45.9854C13.9502 45.9854 12.9302 44.3743 13.4868 42.9392C15.3957 38.0178 16.4427 32.6666 16.4427 27.0708C16.4427 21.4751 15.3957 16.1239 13.4868 11.2025C12.9302 9.76739 13.9502 8.15625 15.4894 8.15625C16.3271 8.15625 17.0881 8.65439 17.3949 9.43393C19.5446 14.896 20.7253 20.8455 20.7253 27.0708C20.7253 33.2962 19.5446 39.2457 17.3949 44.7078C17.0881 45.4873 16.3271 45.9854 15.4894 45.9854Z",
    fill: "url(#paint5_linear_21_351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7584 41.7029C24.3483 41.7029 23.3324 40.3498 23.6511 38.9762C24.5386 35.1512 25.0078 31.1658 25.0078 27.0708C25.0078 22.9759 24.5386 18.9905 23.6511 15.1655C23.3324 13.7919 24.3483 12.4388 25.7584 12.4388C26.718 12.4388 27.5618 13.0833 27.7817 14.0174C28.7684 18.2084 29.2904 22.5787 29.2904 27.0708C29.2904 31.563 28.7684 35.9333 27.7817 40.1243C27.5618 41.0584 26.718 41.7029 25.7584 41.7029Z",
    fill: "url(#paint6_linear_21_351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4633 35.2791C34.173 35.2791 33.1813 34.1419 33.3022 32.8573C33.4813 30.9526 33.5729 29.0224 33.5729 27.0708C33.5729 25.1193 33.4813 23.1891 33.3022 21.2844C33.1813 19.9998 34.173 18.8626 35.4633 18.8626C36.5382 18.8626 37.4488 19.6625 37.5518 20.7324C37.7527 22.8181 37.8555 24.9325 37.8555 27.0708C37.8555 29.2092 37.7527 31.3236 37.5518 33.4093C37.4488 34.4792 36.5382 35.2791 35.4633 35.2791Z",
    fill: "url(#paint7_linear_21_351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.371 24.333L45.5947 25.5567C46.431 26.393 46.431 27.7487 45.5947 28.585L44.371 29.8087C43.4717 30.708 41.9341 30.071 41.9341 28.7993V25.3424C41.9341 24.0706 43.4717 23.4337 44.371 24.333Z",
    fill: "url(#paint8_linear_21_351)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddddd_21_351",
    x: 12.5204,
    y: 8.1189,
    width: 43.1302,
    height: 54.7693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0437548,
    dy: 0.119671
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.078512
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.482353 0 0 0 0.0648125 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_351"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.188482,
    dy: 0.515508
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.148023
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.482353 0 0 0 0.1105 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_21_351",
    result: "effect2_dropShadow_21_351"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.454377,
    dy: 1.24274
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.247538
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.482353 0 0 0 0.143438 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_21_351",
    result: "effect3_dropShadow_21_351"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.861634,
    dy: 2.35661
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.416064
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.482353 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_21_351",
    result: "effect4_dropShadow_21_351"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.43045,
    dy: 3.91233
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.692606
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.482353 0 0 0 0.196562 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_21_351",
    result: "effect5_dropShadow_21_351"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.18101,
    dy: 5.96516
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.11617
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.482353 0 0 0 0.2295 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_21_351",
    result: "effect6_dropShadow_21_351"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.13352,
    dy: 8.57031
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.72576
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.482353 0 0 0 0.275187 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect6_dropShadow_21_351",
    result: "effect7_dropShadow_21_351"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.30817,
    dy: 11.783
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.56039
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.482353 0 0 0 0.34 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect7_dropShadow_21_351",
    result: "effect8_dropShadow_21_351"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect8_dropShadow_21_351",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iii_21_351",
    x: 13.141,
    y: 7.38813,
    width: 33.2727,
    height: 39.1083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.192029,
    dy: 0.512078
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.320049
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21_351"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.192029,
    dy: -0.384059
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.576088
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.309804 0 0 0 0 0.964706 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_21_351",
    result: "effect2_innerShadow_21_351"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.768118
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.384059
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.28 0 0 0 0 0.92 0 0 0 0 0.92 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_21_351",
    result: "effect3_innerShadow_21_351"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_351",
    x1: 11.4069,
    y1: -2.32398,
    x2: 44.5931,
    y2: 56.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312B9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_351",
    x1: 42.1021,
    y1: 33.6716,
    x2: 25.1089,
    y2: 22.4796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21_351",
    x1: 42.1021,
    y1: 33.6716,
    x2: 25.1089,
    y2: 22.4796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21_351",
    x1: 42.1021,
    y1: 33.6716,
    x2: 25.1089,
    y2: 22.4796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_21_351",
    x1: 42.1021,
    y1: 33.6716,
    x2: 25.1089,
    y2: 22.4796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_21_351",
    x1: 42.1021,
    y1: 33.6716,
    x2: 25.1089,
    y2: 22.4796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_21_351",
    x1: 42.1021,
    y1: 33.6716,
    x2: 25.1089,
    y2: 22.4796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_21_351",
    x1: 42.1021,
    y1: 33.6716,
    x2: 25.1089,
    y2: 22.4796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_21_351",
    x1: 42.1021,
    y1: 33.6716,
    x2: 25.1089,
    y2: 22.4796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0EFFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.49c2c3077ed82ff8e76abbb193014d74.svg";
export { ForwardRef as ReactComponent };